import { ToggleBrandFollowArgs } from 'types/api/arguments/toggle-brand-follow-args'
import { ToggleBrandFollowResp } from 'types/api/response/toggle-brand-follow-resp'

import { api } from './api'

export const toggleBrandFollow = ({ brandId }: ToggleBrandFollowArgs) =>
  api.post<ToggleBrandFollowResp>('/brands/toggle_follow', {
    brand_id: brandId,
  })
